import groq from 'groq';

export const DURATION = groq`
  _type == 'timeline_podcast' => {
    "duration": round(episode.duration / 60)
  }
`;
